import { render, staticRenderFns } from "./CompareTableAssessment.vue?vue&type=template&id=24ad1dec"
import script from "./CompareTableAssessment.vue?vue&type=script&lang=js"
export * from "./CompareTableAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports